import * as React from 'react';
import { connect } from 'react-redux';
import { productInfoDeferred } from '../actions/Actions';
import { IPaymentDetails, IReferer } from '../CustomTypes';
import { padWithZerosLengthTwo } from '../fastflowUtils';
import { svgSpid } from '../icons';
import './PaymentMethods.scss';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IOwnProps {
  paymentMethods?: IPaymentDetails[];
  selectedPaymentMethodId?: number;
  userLoggedIn?: boolean;
  owningClient?: string;
  addCardUrl?: string;
  setSelectedPaymentMethod?: (p: IPaymentDetails) => void;
  showSelectPaymentMethodWarning?: boolean;
  showPurchaseFailedWarning?: boolean;
}
export interface IStateProps {
  basename?: string;
  referer: IReferer;
}
export interface IProps extends IOwnProps, IStateProps {}
class PaymentMethods extends React.Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
    this.trackAddPayment = this.trackAddPayment.bind(this);
  }

  public render() {
    const {
      paymentMethods,
      selectedPaymentMethodId,
      showSelectPaymentMethodWarning,
      showPurchaseFailedWarning,
      basename
    } = this.props;
    return (
      <div className="kredittkortframe">
        <span className="icon">{svgSpid(20)}</span>
        <span className="selectPaymentMethodHeader">
          <span style={{ width: '72%' }}>VELG BETALINGSMÅTE</span>
        </span>
        <div className="introText">
          {showSelectPaymentMethodWarning && (
            <div className="alert alert-warning">
              Vennligst velg betalingsmåte
            </div>
          )}
          {showPurchaseFailedWarning && (
            <div className="alert alert-validation">
              Beklager, men vi klarte ikke å trekke penger på valgt kort. Sjekk
              at det er dekning på konto, eller legg til et nytt kort.
            </div>
          )}
        </div>

        <div className="payment-list">
          {paymentMethods &&
            paymentMethods.filter(m => m.type === 'PAYEX_CC').map(m => {
              const selected = selectedPaymentMethodId === m.id;
              const maskedNumber = m.details.maskedNumber
                .replace(/(.{4})/g, '$1 ')
                .trim();
              const { month, year } = m.details.expiryDate;
              const expiryDate = `${padWithZerosLengthTwo(
                month
              )}/${padWithZerosLengthTwo(year)}`;
              return (
                <div
                  key={m.id}
                  className={'paymentinfo ' + (selected ? 'selected' : '')}
                >
                  <input
                    type="radio"
                    id={`payment-method-${m.id}`}
                    name="payment-method"
                    value={m.id}
                    checked={selectedPaymentMethodId === m.id}
                    onChange={() => this.props.setSelectedPaymentMethod(m)}
                  />
                  <label htmlFor={`payment-method-${m.id}`}>
                    <span
                      style={{ whiteSpace: 'nowrap' }}
                      className="paymentLogo"
                    >
                      <img
                        src={`${basename}img/card-${
                          m.details.paymentMethod
                        }.png`}
                        alt={m.details.paymentMethod}
                      />
                      <span className="text">
                        {maskedNumber} ({expiryDate})
                      </span>
                    </span>
                  </label>
                </div>
              );
            })}
          {paymentMethods &&
            paymentMethods.filter(m => m.type === 'STREX').map(m => {
              const selected = selectedPaymentMethodId === m.id;
              const phoneNumber = m.details.phoneNumber;
              return (
                <div
                  key={m.id}
                  className={'paymentinfo ' + (selected ? 'selected' : '')}
                >
                  <input
                    type="radio"
                    id={`payment-method-${m.id}`}
                    name="payment-method"
                    value={m.id}
                    checked={selectedPaymentMethodId === m.id}
                    onChange={() => this.props.setSelectedPaymentMethod(m)}
                  />
                  <label htmlFor={`payment-method-${m.id}`}>
                    <span
                      style={{ whiteSpace: 'nowrap' }}
                      className="paymentLogo"
                    >
                      <img
                        src={`${basename}img/STREX.png`}
                        alt={m.details.paymentMethod}
                      />
                      <span className="text">Mobilregning +{phoneNumber}</span>
                    </span>
                  </label>
                </div>
              );
            })}
        </div>
        <div className="addPaymentMethod">
          <span className="glyphicon glyphicon-plus" />
          <a href={this.props.addCardUrl} onClick={this.trackAddPayment}>
            Andre betalingsmuligheter
          </a>
        </div>
      </div>
    );
  }

  private trackAddPayment() {
    productInfoDeferred.promise.then(product => {
      sccPulseTrackPageView(product, {}, 'SPiD add payment method');
    });
  }
}

export default connect<IStateProps, {}, IOwnProps>(state => ({
  basename: state.router.location.basename,
  referer: state.referer
}))(PaymentMethods);



// WEBPACK FOOTER //
// ./src/input-components/PaymentMethods.tsx